import OfficeForm from '@/views/App/Office/Form.vue';
import OfficeList from '@/views/App/Office/List.vue';
import {UserRole} from "@/shared/enums/UserRolesEnums";

const routesOffice = [
    {
        path: 'list',
        name: 'officeList',
        component: OfficeList,
        meta: {
            roles: [ // Exclude site manager
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ
            ],
        },
    },
    {
        path: 'form/:id?',
        name: 'officeForm',
        component: OfficeForm,
        meta: {
            roles: [ // Exclude site manager
                UserRole.ADMIN,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.HEAD_OF_AMDL,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PRACTICE_MANAGER,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ
            ],
        },
    },
  ];

export default routesOffice;